var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isOOW
        ? _c(
            "details",
            {
              ref: "detailsElement",
              staticClass: "warranty-details",
              attrs: { open: "" },
            },
            [
              _c("summary", [_vm._v("Device is out of warranty")]),
              _vm._v(" "),
              _c("div", { staticClass: "warranty-content" }, [
                _vm.warrantyEndsAt || _vm.oowReason
                  ? _c("div", { staticClass: "el-alert" }, [
                      _vm.warrantyEndsAt
                        ? _c("span", [
                            _vm._v("Manufacturer warranty expiration date: "),
                            _c(
                              "strong",
                              [
                                _c("time-zone-formatter", {
                                  attrs: {
                                    "output-format": "DD MMMM, YYYY",
                                    "current-time": _vm.warrantyEndsAt,
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.oowReason
                        ? _c("span", [
                            _vm._v("Out of warranty reason: "),
                            _c("strong", [_vm._v(_vm._s(_vm.oowReason))]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filteredRestrictions, function (text) {
        return _c("div", { key: text, staticClass: "restriction-item" }, [
          _c("span", { staticClass: "custom-square restriction-text" }, [
            _vm._v(_vm._s(text)),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n        Please review the "),
      _c(
        "a",
        {
          attrs: {
            href: "https://ring.com/support/internal/articles/djk41/device-warranty-and-replacement-eligibility-process",
            target: "_blank",
          },
        },
        [_vm._v("OOW Support Page")]
      ),
      _vm._v(
        " and offer the neighbor an out of warranty discount code.\n      "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }